import { useEffect, useState } from "react";
import Markdown from "react-markdown";
import { useParams } from "react-router-dom";
import rehypeRaw from "rehype-raw";
import api from "../api";
import { ReactComponent as ClockIcon } from "../assets/images/icons/ic-clock.svg";
import { Each } from "../common/Each";
import CourseBadge from "./CourseBadge";
import HeaderFooterLayout from "./layouts/HeaderFooterLayout";
import MaterialButton from "./MaterialButton";
import VideoPlayer from "./VideoPlayer";
import typo from "../typography.module.css";
import { capitalize, formatDateV2, formatTimeV2 } from "../utils";
import styles from "./Lesson.module.css";


const Lesson = () => {

  const { roomName } = useParams();
  const [lesson, setLesson] = useState(null);
  const [materials, setMaterials] = useState([]);

  useEffect(() => {
    const getLesson = async (roomName) => {
      try {
        const lesson = await api.get(`/teacher/lessons/${roomName}`);
        setLesson(lesson)
      } catch (e) {
        console.error(e)
      }
    };

    if (roomName) {
      getLesson(roomName);
    }
  }, [roomName]);

  useEffect(() => {

    const getLessonMaterial = async (lessonId) => {
      try {
        const materials = await api.get(`/teacher/lessons/${lessonId}/materials`);

        setMaterials(materials);
      } catch (e) {
        console.error(e);
      }
    };

    if (lesson) {
      getLessonMaterial(lesson.id)
    }
  }, [lesson])

  const renderNoLessonMessage = (message) => (
    <div className={styles.noLesson}>
      <div className={typo.headline} style={{ color: 'var(--background-color)' }}>
        {message}
      </div>
    </div>
  );

  return (
    <div className={styles.container}>
      {lesson && (
        <>
          <div
            className={styles.section}
            style={{ backgroundColor: "var(--background-color)" }}
          >
            <div className={styles.sectionInner} style={{ paddingBottom: 0 }}>
              <div className={styles.videoPlaceholder}>
                {lesson.video_url &&
                  <div className={styles.playerWrapper}>
                    <VideoPlayer
                      url={lesson.video_url}
                      thumbnail={lesson.thumbnail}
                      max={0}
                      progressBlock={false}
                      onProgress={() => { }}
                    />
                  </div>
                }

                {lesson.ended_at && !lesson.video_url &&
                  renderNoLessonMessage(`La lezione è terminata ${formatDateV2(lesson.ended_at)} alle ${formatTimeV2(lesson.ended_at)}. La registrazione sarà disponibile a breve.`)
                }
              </div>
            </div>
          </div>
          <div
            className={styles.section}
            style={{ backgroundColor: "var(--background-color)" }}
          >
            <div className={styles.sectionInner} style={{ paddingBottom: 0 }}>
              <div className={styles.lessonHeader}>
                <div className={styles.lessonTitle}>
                  <div className={typo.title}>
                    <CourseBadge type={lesson?.module.edition.course.type} />
                    {lesson?.module.name} - {lesson?.name}
                  </div>
                  <div className={styles.lessonDate}>
                  </div>
                  <div className={styles.lessonTime}>
                    {capitalize(formatDateV2(lesson.starts_at, { weekday: 'short', day: 'numeric', month: 'short' }))}
                    {', '}
                    {formatTimeV2(lesson.starts_at)} -{" "}
                    {formatTimeV2(lesson.ends_at)}
                    <ClockIcon style={{ minWidth: '16px', minHeight: '16px' }} />
                  </div>
                </div>
                {lesson?.description &&
                  <div className={styles.lessonDescription}>
                    <Markdown children={lesson.description} rehypePlugins={[rehypeRaw]} />
                  </div>
                }
              </div>
            </div>

            {materials.length > 0 &&
              <div className={styles.sectionInner} style={{ flexDirection: "column", paddingTop: "1rem" }}>
                <div className={typo.subheadline}>
                  Materiali didattici
                </div>
                <div className={styles.materials}>
                  <Each of={materials} render={(item) =>
                    <div className={styles.material}>
                      <MaterialButton material={item} />
                    </div>
                  } />
                </div>
              </div>
            }
          </div>
        </>
      )}
    </div>
  );
};

export default Lesson;
